export default __webpack_public_path__ + "static/media/clover.ba0e4414.svg";